/* jshint esversion: 6 */
/* jshint ignore:start */
import { useContext, useEffect, useRef, useState } from 'react';
import Login from './Login&Signup/Login';
import { MyContext } from '../Context/MyProvider';
import Signup from './Login&Signup/Signup';
import SelectCar from './SelectCar';
import axios from 'axios';
import { showToast } from '../showTost';
import PetrolLogo from "../image/petrol.png";
import DieselLogo from "../image/fuel.png";
import CngLogo from "../image/cnglogo.png";
import { Link, useNavigate } from 'react-router-dom';
import secureLocalStorage from "react-secure-storage";
import { useTranslation } from 'react-i18next';
import LocationImg from "../image/permission.png";
import CryptoJS from "crypto-js";
import Logo from "../icon/Logo.svg";
import OneSignal from 'react-onesignal';
const Header = () => {

    const { t, i18n } = useTranslation();
    const { ApiBasUrl, ImgBasUrl, showloginpage, setShowLoginPage, guestmooddata, setCartStatus, setTotalCart, showsignuppage, setShowSignupPage, setCallApi, showselectcarpage, setShowSelectCarPage, islogin, setIsLogin, selectmodel, setSelectModel, totalcart, SECRET_KEY, OneSignalUserAppId, isInstallable, setIsInstallable, isguestmode, setIsGuestMood } = useContext(MyContext);

    const [userimg, setUserImg] = useState("");
    const [search, setSearch] = useState("");
    const [searchbtn, setSearchBtn] = useState(0);
    const [showsearch, setShowSearch] = useState(false);
    const [searchservicelist, setSearchServiceList] = useState([]);
    const [searchaccessorilist, setSearchAccessoriList] = useState([]);
    const [errortext, setErrorText] = useState("");
    const [searchlod, setSearchLod] = useState(false);
    const [selectgeartype, setSelectGearType] = useState("");
    const [selectfueltype, setSelectFuelType] = useState("");
    const [input, setInput] = useState("");
    const [showstorelist, setShowStoreList] = useState(false);
    const [showcarlist, setShowCarList] = useState(false);
    const [storelist, setStoreList] = useState([]);
    const [selectstore, setSelectStore] = useState("");
    const [carlist, setCarList] = useState([]);
    const [selectcar, setSelectCar] = useState("");
    const [copyselectcar, setCopySelectCar] = useState("");
    const [apiloading, setApiLoading] = useState(false);
    const [showmenu, setShowMenu] = useState(false);
    const [pagelist, setPageList] = useState([]);
    const [showlanglist, setShowLangList] = useState(false);
    const [selectlang, setSelectLang] = useState("en");
    const [username, setUserName] = useState("");
    const [cartItems, setCartItems] = useState([]);
    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState("");
    const [lastScrollTop, setLastScrollTop] = useState(0);
    const [hasMore, setHasMore] = useState(true);
    const [locationError, setLocationError] = useState(false);
    const [storeerror, setStoreError] = useState("");
    const [deferredPrompt, setDeferredPrompt] = useState(null);

    const NoMoreDataRef = useRef(true);
    const initialized = useRef(false);
    const MenuRef = useRef();
    const ShowCarListRef = useRef();
    const ShowStoreListRef = useRef();
    const SearchRef = useRef();
    const Navigate = useNavigate();

    const Userid = secureLocalStorage.getItem("Userid");
    const Store = secureLocalStorage.getItem("Store");
    const Currency = secureLocalStorage.getItem("currency");
    const SelectCarData = secureLocalStorage.getItem("Selectcar");

    const MenuList = [
        {
            title: "My Order", path: "/order-history", icon: <svg width="100%" height="100%" className='mx-auto' viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M21.287 6.88198C21.286 6.87998 21.287 6.878 21.286 6.876C21.284 6.871 21.279 6.868 21.277 6.863C20.89 6.16 20.287 5.57999 19.525 5.24099L13.525 2.574C12.556 2.144 11.447 2.144 10.478 2.574L4.47803 5.24099C3.71503 5.57999 3.11295 6.16 2.72595 6.863C2.72395 6.868 2.71904 6.871 2.71704 6.876C2.71604 6.878 2.71694 6.87998 2.71594 6.88198C2.42294 7.42098 2.25305 8.02898 2.25305 8.66698V15.334C2.25305 16.814 3.12698 18.159 4.47998 18.761L10.48 21.428C10.962 21.642 11.479 21.748 11.996 21.75C11.999 21.75 12.001 21.751 12.004 21.751C12.007 21.751 12.009 21.75 12.012 21.75C12.529 21.749 13.046 21.642 13.528 21.428L19.528 18.761C20.881 18.16 21.755 16.815 21.755 15.334V8.66698C21.75 8.02898 21.58 7.41998 21.287 6.88198ZM11.0861 3.94399C11.3761 3.81499 11.689 3.74999 12 3.74999C12.311 3.74999 12.6239 3.81398 12.9139 3.94298L18.9139 6.60998C19.0839 6.68598 19.233 6.791 19.376 6.902L16.6429 8.11699L9.38403 4.7L11.0861 3.94399ZM7.573 5.505L14.832 8.92199L12.92 9.77199C12.334 10.027 11.663 10.027 11.085 9.77398L4.62402 6.902C4.76702 6.791 4.91606 6.68498 5.08606 6.60998L7.573 5.505ZM5.08606 17.389C4.27406 17.028 3.75 16.221 3.75 15.333V8.66598C3.75 8.50098 3.78595 8.343 3.81995 8.187L10.48 11.147C10.729 11.255 10.987 11.334 11.25 11.386V20.108C11.196 20.089 11.1391 20.078 11.0861 20.055L5.08606 17.389ZM20.25 15.333C20.25 16.221 19.7259 17.028 18.9139 17.389L12.9139 20.056C12.8609 20.08 12.804 20.09 12.75 20.109V11.386C13.014 11.333 13.274 11.254 13.524 11.145L15.879 10.098V11.89C15.879 12.304 16.215 12.64 16.629 12.64C17.043 12.64 17.379 12.304 17.379 11.89V9.432L20.179 8.18798C20.214 8.34498 20.249 8.50198 20.249 8.66698V15.333H20.25Z" fill="currentColor" />
            </svg>
        }, {
            title: "Accessorie", path: "/accessorie", icon: <svg width="100%" height="100%" className='mx-auto' viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M21.271 6.284C21.177 6.051 20.972 5.88099 20.726 5.82999C20.479 5.77899 20.224 5.85599 20.047 6.03299L17.865 8.20401C17.578 8.49001 17.111 8.49 16.823 8.203L15.798 7.17801C15.511 6.89101 15.51 6.42301 15.797 6.13501L17.968 3.95401C18.145 3.77601 18.221 3.52099 18.171 3.27499C18.121 3.02899 17.95 2.82401 17.717 2.73001C15.795 1.95301 13.654 2.131 11.841 3.216C11.019 3.709 10.323 4.386 9.83 5.172C9.83 5.172 9.82899 5.17301 9.82899 5.17401L9.74699 5.30899C8.93499 6.65199 8.621 8.15901 8.84 9.67001C8.871 9.88401 8.792 10.11 8.629 10.274L3.306 15.597C2.625 16.278 2.25 17.183 2.25 18.147C2.25 19.111 2.625 20.015 3.306 20.696C3.987 21.377 4.892 21.752 5.856 21.752C6.819 21.752 7.724 21.377 8.405 20.696L13.728 15.373C13.891 15.21 14.118 15.131 14.332 15.162C15.84 15.381 17.344 15.071 18.681 14.266C19.544 13.747 20.269 13.022 20.774 12.173C21.869 10.359 22.051 8.213 21.271 6.284ZM19.487 11.401C19.106 12.042 18.56 12.588 17.907 12.979C16.598 13.768 15.357 13.793 14.548 13.676C13.864 13.576 13.164 13.814 12.668 14.311L7.345 19.634C6.548 20.43 5.162 20.429 4.367 19.634C3.97 19.236 3.75 18.707 3.75 18.145C3.75 17.583 3.969 17.054 4.367 16.656L9.69099 11.333C10.187 10.836 10.424 10.134 10.325 9.45401C10.157 8.29201 10.401 7.127 11.035 6.078L11.102 5.96799C11.47 5.38199 11.993 4.87499 12.612 4.50299C13.886 3.73999 15.082 3.66499 16 3.80499L14.733 5.077C13.865 5.95 13.866 7.36801 14.737 8.23901L15.762 9.263C16.633 10.135 18.051 10.136 18.924 9.267L20.195 8.00201C20.364 9.15701 20.123 10.348 19.487 11.401ZM6.02 17H6.00999C5.45799 17 5.015 17.448 5.015 18C5.015 18.552 5.468 19 6.02 19C6.572 19 7.02 18.552 7.02 18C7.02 17.448 6.572 17 6.02 17Z" fill="currentColor" />
            </svg>
        }, {
            title: "Wallet", path: "/wallet", icon: <svg width="100%" height="100%" className='mx-auto' viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M18.75 6.297V6C18.75 3.582 17.418 2.25 15 2.25H5C3.483 2.25 2.25 3.483 2.25 5V18C2.25 20.418 3.582 21.75 6 21.75H18C20.418 21.75 21.75 20.418 21.75 18V10C21.75 7.845 20.692 6.553 18.75 6.297ZM20.25 15.75H16.5C15.535 15.75 14.75 14.965 14.75 14C14.75 13.035 15.535 12.25 16.5 12.25H20.25V15.75ZM5 3.75H15C16.577 3.75 17.25 4.423 17.25 6V6.25H5C4.311 6.25 3.75 5.689 3.75 5C3.75 4.311 4.311 3.75 5 3.75ZM18 20.25H6C4.423 20.25 3.75 19.577 3.75 18V7.44897C4.125 7.64097 4.55 7.75 5 7.75H18C19.577 7.75 20.25 8.423 20.25 10V10.75H16.5C14.708 10.75 13.25 12.208 13.25 14C13.25 15.792 14.708 17.25 16.5 17.25H20.25V18C20.25 19.577 19.577 20.25 18 20.25ZM17.01 13H17.02C17.573 13 18.02 13.448 18.02 14C18.02 14.552 17.573 15 17.02 15C16.468 15 16.015 14.552 16.015 14C16.015 13.448 16.458 13 17.01 13Z" fill="currentColor" />
            </svg>
        }, {
            title: "Chat", path: "/chat", icon: <svg width="100%" height="100%" className='mx-auto' viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M3.85693 21.75C3.71193 21.75 3.57111 21.748 3.43311 21.743C2.93311 21.731 2.49497 21.411 2.32397 20.928C2.15197 20.442 2.29408 19.9131 2.68408 19.5811C3.61608 18.8291 3.98892 17.997 4.13892 17.426C2.90192 15.947 2.24902 14.08 2.24902 12.001C2.24902 6.84798 6.25902 3.25 11.999 3.25C17.739 3.25 21.749 6.84898 21.749 12.001C21.749 17.153 17.739 20.752 11.999 20.752C10.812 20.752 9.67398 20.591 8.60498 20.2729C7.24198 21.4599 5.36393 21.75 3.85693 21.75ZM3.47803 20.243C3.48003 20.243 3.48189 20.243 3.48389 20.243C3.48089 20.244 3.47903 20.244 3.47803 20.243ZM12 4.75C7.143 4.75 3.75 7.73198 3.75 12.001C3.75 13.837 4.35498 15.463 5.50098 16.703C5.65598 16.871 5.72692 17.101 5.69092 17.328C5.52292 18.399 4.99511 19.412 4.18311 20.243C5.34311 20.201 6.90304 19.934 7.86304 18.91C8.06404 18.694 8.37603 18.617 8.65503 18.714C9.69003 19.072 10.815 19.2531 12 19.2531C16.857 19.2531 20.25 16.271 20.25 12.002C20.25 7.73295 16.857 4.75 12 4.75ZM13.02 12C13.02 11.448 12.573 11 12.02 11H12.01C11.458 11 11.0149 11.448 11.0149 12C11.0149 12.552 11.468 13 12.02 13C12.572 13 13.02 12.552 13.02 12ZM17.02 12C17.02 11.448 16.573 11 16.02 11H16.01C15.458 11 15.0149 11.448 15.0149 12C15.0149 12.552 15.468 13 16.02 13C16.572 13 17.02 12.552 17.02 12ZM9.02002 12C9.02002 11.448 8.57302 11 8.02002 11H8.01001C7.45801 11 7.01489 11.448 7.01489 12C7.01489 12.552 7.46802 13 8.02002 13C8.57202 13 9.02002 12.552 9.02002 12Z" fill="currentColor" />
            </svg>
        }, {
            title: "Edit Profile", path: "/profile", icon: <svg width="100%" height="100%" className='mx-auto' viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M22.75 12C22.75 6.072 17.928 1.25 12 1.25C6.072 1.25 1.25 6.072 1.25 12C1.25 15.47 2.90899 18.552 5.46899 20.519C5.47299 20.523 5.47903 20.5251 5.48303 20.5291C7.29403 21.9161 9.54898 22.75 12.001 22.75C14.453 22.75 16.708 21.9161 18.519 20.5291C18.523 20.5251 18.529 20.523 18.533 20.519C21.091 18.552 22.75 15.47 22.75 12ZM2.75 12C2.75 6.899 6.899 2.75 12 2.75C17.101 2.75 21.25 6.899 21.25 12C21.25 14.523 20.232 16.8121 18.588 18.4821C18.139 16.5811 16.702 14.8199 13.71 14.8199H10.29C7.29804 14.8199 5.85999 16.5811 5.41199 18.4821C3.76799 16.8121 2.75 14.523 2.75 12ZM6.75903 19.614C6.81703 18.588 7.28604 16.3199 10.29 16.3199H13.71C16.714 16.3199 17.183 18.588 17.241 19.614C15.75 20.644 13.945 21.25 12 21.25C10.055 21.25 8.25003 20.643 6.75903 19.614ZM12.0081 13.75C14.0751 13.75 15.7581 12.068 15.7581 10C15.7581 7.932 14.0751 6.25 12.0081 6.25C9.94106 6.25 8.25806 7.932 8.25806 10C8.25806 12.068 9.94006 13.75 12.0081 13.75ZM12.0081 7.75C13.2481 7.75 14.2581 8.759 14.2581 10C14.2581 11.241 13.2481 12.25 12.0081 12.25C10.7681 12.25 9.75806 11.241 9.75806 10C9.75806 8.759 10.7681 7.75 12.0081 7.75Z" fill="currentColor" />
            </svg>
        }, {
            title: "Refer and Earn", path: "/referEarn", icon: <svg width="100%" height="100%" viewBox="0 0 24 24" className='mx-auto' fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M16.321 6.42505L17.236 4.90002C17.564 4.35202 17.572 3.69296 17.257 3.13696C16.942 2.58096 16.373 2.25 15.735 2.25H8.26501C7.62601 2.25 7.05701 2.58196 6.74301 3.13696C6.42901 3.69296 6.43601 4.35202 6.76501 4.90002L7.67899 6.42505C4.73999 9.13705 3.25 12.019 3.25 15C3.25 16.583 3.881 21.75 12 21.75C20.119 21.75 20.75 16.583 20.75 15C20.75 12.019 19.261 9.13705 16.321 6.42505ZM8.048 3.87598C8.075 3.82898 8.13901 3.75 8.26501 3.75H15.735C15.861 3.75 15.925 3.82998 15.952 3.87598C15.979 3.92298 16.014 4.02005 15.949 4.12805L14.935 5.81897H9.065L8.05099 4.12805C7.98599 4.02005 8.021 3.92398 8.048 3.87598ZM12 20.25C5.457 20.25 4.75 16.579 4.75 15C4.75 12.382 6.165 9.79995 8.935 7.31995H15.065C17.836 9.79995 19.25 12.382 19.25 15C19.25 16.579 18.543 20.25 12 20.25ZM12.818 13.433L11.553 13.114C11.393 13.072 11.257 12.982 11.153 12.847C11.054 12.72 11 12.556 11 12.387C11 11.974 11.325 11.639 11.725 11.639H12.276C12.645 11.639 12.954 11.9251 12.996 12.3051C13.041 12.7171 13.406 13.011 13.824 12.968C14.236 12.923 14.532 12.551 14.487 12.14C14.379 11.163 13.665 10.3969 12.75 10.1949V10C12.75 9.586 12.414 9.25 12 9.25C11.586 9.25 11.25 9.586 11.25 10V10.193C10.251 10.414 9.5 11.312 9.5 12.387C9.5 12.888 9.66699 13.378 9.96399 13.762C10.265 14.157 10.696 14.442 11.182 14.567L12.447 14.886C12.773 14.97 13 15.269 13 15.613C13 15.813 12.923 16.002 12.782 16.145C12.645 16.285 12.465 16.361 12.275 16.361H11.724C11.355 16.361 11.046 16.0749 11.004 15.6949C10.958 15.2829 10.593 14.987 10.176 15.032C9.76399 15.077 9.468 15.449 9.513 15.86C9.621 16.837 10.335 17.6031 11.25 17.8051V18C11.25 18.414 11.586 18.75 12 18.75C12.414 18.75 12.75 18.414 12.75 18V17.807C13.164 17.716 13.545 17.509 13.851 17.198C14.269 16.774 14.5 16.211 14.5 15.614C14.5 14.584 13.81 13.688 12.818 13.433Z" fill="currentColor" />
            </svg>
        }, {
            title: "Language", path: "language", icon: <svg width="100%" height="100%" viewBox="0 0 24 24" className='mx-auto' fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 1.25C6.072 1.25 1.25 6.073 1.25 12C1.25 17.927 6.072 22.75 12 22.75C17.928 22.75 22.75 17.927 22.75 12C22.75 6.073 17.928 1.25 12 1.25ZM21.212 11.25H17.162C17.031 8.507 16.187 5.71201 14.727 3.16101C18.27 4.25701 20.903 7.43 21.212 11.25ZM12.73 2.78699C14.486 5.39799 15.509 8.36 15.662 11.25H8.33801C8.49001 8.36 9.51399 5.39799 11.27 2.78699C11.512 2.76799 11.754 2.75 12 2.75C12.246 2.75 12.489 2.76799 12.73 2.78699ZM9.27301 3.16101C7.81301 5.71201 6.96901 8.507 6.83801 11.25H2.78799C3.09699 7.43 5.73001 4.25701 9.27301 3.16101ZM2.78799 12.75H6.83801C6.96901 15.493 7.81301 18.288 9.27301 20.839C5.73001 19.743 3.09699 16.57 2.78799 12.75ZM11.27 21.213C9.51399 18.602 8.49101 15.64 8.33801 12.75H15.662C15.51 15.64 14.486 18.602 12.73 21.213C12.488 21.232 12.246 21.25 12 21.25C11.754 21.25 11.511 21.232 11.27 21.213ZM14.727 20.839C16.187 18.288 17.031 15.493 17.162 12.75H21.212C20.903 16.57 18.27 19.743 14.727 20.839Z" fill="currentColor" />
            </svg>
        }];

    const LanguageList = [{ id: "en", name: "English", img: require("../image/english.png") }, { id: "sp", name: "Spanish", img: require("../image/spain.png") }, { id: "ar", name: "Arabic", img: require("../image/united-arab-emirates.png") }, { id: "hi", name: "Hindi", img: require("../image/in.png") }, { id: "gu", name: "Gujarati", img: require("../image/in.png") }, { id: "af", name: "Afrikaans", img: require("../image/afrikaans.png") }, { id: "be", name: "Bengali", img: require("../image/bengali.png") }, { id: "in", name: "Indonesian", img: require("../image/indonesia-flag.png") },];

    useEffect(() => {
        const LoginData = secureLocalStorage.getItem("LoginData");
        const Store = secureLocalStorage.getItem("Store");

        if (LoginData) {
            const { profile_pic, name } = JSON.parse(LoginData);

            if (profile_pic) {
                setUserImg(ImgBasUrl + profile_pic);
            } else {
                setUserImg("NoPic");
                setUserName(name);
            }

        } else {
            if (!Store && SelectCarData) {
                HandleGetStoreList(JSON.parse(SelectCarData));
                setShowStoreList(true);
            }
        }

        if (SelectCarData) {
            setSelectCar(JSON.parse(SelectCarData));
        }

        if (Store) {
            setSelectStore(JSON.parse(Store));
        }

        HandleGetMyvehicle(SelectCarData);

        HandleGetPageList();
        handleOneSignal();
    }, [islogin]);


    useEffect(() => {
        const savedCart = localStorage.getItem('Cartitem');

        let cartData = [];
        let packageItems = [];

        if (savedCart) {
            const bytes = CryptoJS.AES.decrypt(savedCart, SECRET_KEY);
            const decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
            packageItems = decryptedData.packagecartitem || [];
            cartData = decryptedData.cartitem || [];
            setCartItems(packageItems);
            setTotalCart(packageItems.length + cartData.length);
        }

        navigator.geolocation.getCurrentPosition(
            position => { },
            error => {
                if (!secureLocalStorage.getItem("location")) {
                    setLocationError(true);
                }
            }
        );

        handleOneSignal();
    }, []);

    useEffect(() => {
        i18n.changeLanguage(selectlang);
        secureLocalStorage.setItem("I18", selectlang);
    }, [selectlang]);

    const HandleGetMyvehicle = (SelectCarData) => {
        if (Userid) {

            axios.post(`${ApiBasUrl}/my_vehicle_list.php`, { uid: Userid })
                .then((res) => {
                    const { vehicles } = res.data;

                    if (vehicles.length === 0) {
                        setShowSelectCarPage(true);
                        setShowStoreList(false);
                        return;
                    }

                    const Store = secureLocalStorage.getItem("Store");
                    if (!Store) {
                        setShowStoreList(true);
                    }

                    setCarList(vehicles);

                    if (!SelectCarData) {
                        const defaultCar = vehicles[0];
                        HandleSelectCar(defaultCar, 0);
                    }

                    // HandleGetStoreList(selectcar || vehicles[0]);
                })
                .catch((error) => {
                    console.error("my_vehicle_list.php", error);
                });
        }
    }

    const HandleLogout = () => {
        setShowMenu(false);
        setIsLogin("456");
        showToast({ title: t("Logout successfuly"), id: "success" });
        secureLocalStorage.clear();
        localStorage.clear();
        sessionStorage.clear();
        window.location.href = "/"
    }

    const HandleAddVehicle = () => {

        if (!input || !selectgeartype || !selectfueltype) {
            showToast({ title: t("Please enter detaisl !!"), id: "error" });
            return;
        }

        setApiLoading(true);

        if (Userid) {

            const Data = {
                uid: Userid || 0,
                cat_id: selectmodel?.cat_id,
                brand_id: selectmodel?.brand_id,
                model_id: selectmodel?.model_id,
                reg_number: input,
                fuel_type: selectfueltype,
                transmission_type: selectgeartype
            }

            axios.post(`${ApiBasUrl}/vehicle_save.php`, Data)
                .then((res) => {
                    const { ResponseCode, ResponseMsg, Vehicle } = res.data;
                    const ToastId = ResponseCode === "200" ? "success" : "error";
                    showToast({ title: ResponseMsg, id: ToastId });
                    if (ResponseCode === "200") {
                        HandleGetMyvehicle(SelectCarData);
                        setShowSelectCarPage(false);
                        setSelectModel("");
                        setInput("");
                        setSelectGearType("");
                        setSelectFuelType("");
                        HandleSelectCar(Vehicle, carlist.length);
                        HandleShowStoreList(0);
                    }
                    setApiLoading(false);
                })
                .catch((error) => {
                    console.error("vehicle_save.php", error);
                });

        } else {
            setApiLoading(false);
            HandleGetMyvehicle("");
            setShowSelectCarPage(false);
            setSelectModel("");
        }
    }

    useEffect(() => {
        if (!guestmooddata) return;
        setSelectCar(guestmooddata);
        setCopySelectCar(guestmooddata);
        HandleGetStoreList(guestmooddata);
        setShowStoreList(true);
        handleModelOpen(ShowStoreListRef, "store_list_open", setShowStoreList);
    }, [guestmooddata]);

    const HandleGetStoreList = (Data) => {

        if (!Userid) {
            const Isisguestmode = secureLocalStorage.getItem("Guest");
            setIsGuestMood(Isisguestmode);
        } else {
            setIsGuestMood(true);
        }

        setApiLoading(true);

        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    const lat = position.coords.latitude;
                    const long = position.coords.longitude;
                    axios.post(`${ApiBasUrl}/store_list.php`, { cat_id: Data?.cat_id, lats: lat, longs: long })
                        .then((res) => {
                            if (res.data.ResponseCode === "200") {
                                setApiLoading(false);
                                setStoreList(res.data.store_list);
                                setStoreError(res.data.ResponseMsg);
                            } else {
                                setStoreError(res.data.ResponseMsg);
                            }
                        })
                        .catch((error) => {
                            console.error("store_list.php", error);
                        })
                })
        }
    }

    const HandleSelectStoreList = (item) => {
        handleModelClose(ShowStoreListRef, "store_list_open", setShowStoreList);

        if (selectstore.store_id === item.store_id) {
            setShowStoreList(false);
            return;
        }

        secureLocalStorage.setItem("Store", JSON.stringify({ name: item.store_title, store_id: item.store_id, store_logo: item.store_logo }));
        setSelectStore({ name: item.store_title, store_id: item.store_id, store_logo: item.store_logo });
        setShowStoreList(false);
        secureLocalStorage.setItem("Selectcar", JSON.stringify(copyselectcar));
        setSelectCar(copyselectcar);
        setCallApi((per) => !per);
        setIsGuestMood(false);
        Navigate("/");
    }

    const HandleSelectCar = (item, index) => {
        const Data = {
            index,
            model_img: item.model_img,
            brand_id: item.brand_id,
            cat_id: item.cat_id,
            model_id: item.model_id,
            name: `${item.brand_name} ${item.model_name}`
        }

        setCopySelectCar(Data);
        setShowCarList(false);
        setSelectStore("");
        HandleGetStoreList(item);
        HandleShowStoreList(0);
    }

    const HandleNavigate = (path) => {
        setShowMenu(false);
        if (path === "language") {
            setShowLangList(true);
        } else {
            Navigate(path);
        }

    }

    const HandleGetPageList = () => {
        axios.post(`${ApiBasUrl}/pagelist.php`)
            .then((res) => {
                setPageList(res.data.pagelist);
            })
            .catch((error) => {
                console.error("pagelist.php", error);
            })
    }

    const HandleShowCarList = () => {
        if (Userid) {
            handleModelOpen(ShowCarListRef, "store_list_open", setShowCarList);
            if (showmenu) {
                handleModelClose(MenuRef, "menu_list_open", setShowMenu);
            }
        }
        else {
            setShowLoginPage(true);
        }
    }

    const HandleShowStoreList = (index) => {
        if (Userid) {
            handleModelOpen(ShowStoreListRef, "store_list_open", setShowStoreList);
            if (showmenu) {
                handleModelClose(MenuRef, "menu_list_open", setShowMenu);
            }
            if (index === 1) {
                HandleGetStoreList(selectcar);
            }
        } else {
            setShowMenu(false);
            setShowLoginPage(true);
        }
    }

    const HandleMenuShow = () => {
        if (!Userid) {
            setShowLoginPage(true);
            setIsInstallable(false);
            secureLocalStorage.setItem("pwa", false);
            return;
        }
        const SelectCarData = secureLocalStorage.getItem("Selectcar");
        if (!SelectCarData) {
            setShowSelectCarPage(true);
            return;
        }
        handleModelOpen(MenuRef, "menu_list_open", setShowMenu);
    }

    const HandleCloseCarModel = () => {
        setShowSelectCarPage(false);
        setShowLoginPage(Userid ? false : true);
    }

    useEffect(() => {
        handleSearchData(1);
    }, [search]);

    const handleSearchData = (page) => {
        const SelectStore = secureLocalStorage.getItem("Store");
        const SelectCar = secureLocalStorage.getItem("Selectcar");
        const savedCart = localStorage.getItem('Cartitem');

        if (search) {

            if (page === 1) {
                setSearchLod(true);
            }

            let packageItems = [];

            if (savedCart) {
                const bytes = CryptoJS.AES.decrypt(savedCart, SECRET_KEY);
                const parsed = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
                packageItems = parsed.packagecartitem || [];
            }

            if (SelectStore && SelectCar) {
                var { store_id } = JSON.parse(SelectStore);
                var { brand_id, model_id } = JSON.parse(SelectCar);
            }

            const ApiData = {
                brand_id: brand_id || "1",
                model_id: model_id || "1",
                store_id: store_id || "1",
                page,
                limit: limit ? limit : "5",
                search: search
            }

            axios.post(`${ApiBasUrl}/search_service.php`, ApiData)
                .then((res) => {
                    const { ResponseCode, services, accessories, ResponseMsg, limit_per_page } = res.data;

                    if (ResponseCode === "200") {
                        setLimit(limit_per_page);
                        const enrichedList = accessories.map((accessory) => {
                            const matchedItem = packageItems.find(
                                (item) => item.item_type === 'accessory' && item.service_id === accessory.id
                            );

                            if (matchedItem) {
                                return { ...accessory, totalcart: matchedItem?.totalcart };
                            } else {
                                return accessory;
                            }
                        });

                        if (page === 1) {
                            setSearchServiceList(services);
                            setSearchAccessoriList(enrichedList);
                        } else {
                            setSearchServiceList(prev => [...prev, ...services]);
                            setSearchAccessoriList(prev => [...prev, ...enrichedList]);
                        }
                        setHasMore(true);
                    } else {
                        setSearchServiceList([]);
                        setSearchAccessoriList([]);
                    }
                    setErrorText(ResponseMsg);
                    setSearchLod(false);
                })
                .catch((error) => {
                    console.error("search_service.php", error);
                })
        }
    }

    const handleScroll = (e) => {
        const { scrollTop, scrollHeight, clientHeight } = e.target;

        if (scrollTop > lastScrollTop) {
            if (scrollTop + clientHeight >= scrollHeight - 10 && hasMore && NoMoreDataRef.current) {
                setHasMore(false);
                setPage(prev => prev + 1);
            }
        }
        setLastScrollTop(scrollTop);
    };

    useEffect(() => {
        if (page === 1 || !NoMoreDataRef.current) return;
        handleSearchData(page);
    }, [page]);

    const HandleNavigateDetails = (item) => {
        setSearch("");
        setShowSearch(false);
        Navigate("/details");
        secureLocalStorage.setItem("servicedata", JSON.stringify({ title: item.service_title, service_id: item.service_id }));
    }

    const handleAddToCart = (id, alreadyInCart) => {

        const updatedAccessories = searchaccessorilist.map((item) =>
            item.id === id
                ? { ...item, totalcart: 1 }
                : item
        );

        setSearchAccessoriList(updatedAccessories);

        if (!alreadyInCart) {
            const selected = searchaccessorilist.find((item) => item.id === id);
            const newItem = {
                service_id: selected.id,
                discount_percentage: selected.discount_percentage,
                discount_price: selected.discount_price,
                itemdisprice: selected.discount_price,
                itemprice: selected.price,
                price: selected.price,
                service_img: selected.img,
                service_title: selected.title,
                totalcart: 1,
                item_type: 'accessory',
                totalprice: selected.discount_price
            };
            setCartItems((prev) => [...prev, newItem]);
        }
        setCartStatus(prev => prev + 1);
    }

    const handleIncrement = (id) => {

        const FilterData = searchaccessorilist.map(item => {
            if (item.id === id) {
                const count = item.totalcart + 1;
                return { ...item, totalcart: count }
            } else {
                return item;
            }
        })

        setSearchAccessoriList(FilterData);

        const FilterCartData = cartItems.map(item => {
            if (item.service_id === id) {
                const count = item.totalcart + 1;
                const TotalDicPrice = (Number(item.itemdisprice) * count);
                const TotalPrice = (Number(item.itemprice) * count);
                return { ...item, totalcart: count, discount_price: TotalDicPrice, price: TotalPrice }
            } else {
                return item;
            }
        })

        setCartItems(FilterCartData);
        setCartStatus(prev => prev + 1);
    }

    const handleDecrement = (id) => {

        const FilterData = searchaccessorilist.map(item => {
            if (item.id === id) {
                const count = item.totalcart - 1;
                return { ...item, totalcart: count }
            } else {
                return item;
            }
        })

        setSearchAccessoriList(FilterData);

        const updatedCart = cartItems.map(item => {
            if (item.service_id === id) {
                const count = item.totalcart - 1;
                if (count === 0) {
                    return null;
                } else {
                    const TotalDicPrice = (Number(item.itemdisprice) * count);
                    const TotalPrice = (Number(item.itemprice) * count);
                    return { ...item, totalcart: count, discount_price: TotalDicPrice, price: TotalPrice }
                }
            }
            return item;
        }).filter(item => item !== null);

        setCartItems(updatedCart);
        setCartStatus(prev => prev + 1);
    }

    useEffect(() => {
        updateCartStorage(cartItems);
    }, [cartItems]);

    const updateCartStorage = (newCartItems) => {
        const existing = localStorage.getItem('Cartitem');
        let otherCartItems = [];

        if (existing) {
            const bytes = CryptoJS.AES.decrypt(existing, SECRET_KEY);
            const decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
            otherCartItems = decryptedData.cartitem || [];
        }

        const combined = {
            packagecartitem: [...newCartItems],
            cartitem: [...otherCartItems],
        };

        const total = newCartItems.length + otherCartItems.length;

        if (total > 0) {
            const encrypted = CryptoJS.AES.encrypt(JSON.stringify(combined), SECRET_KEY).toString();
            localStorage.setItem('Cartitem', encrypted);
        } else {
            localStorage.removeItem('Cartitem');
        }
        setTotalCart(total);
    };

    const HandleLocationEnable = () => {
        setLocationError(false);
        secureLocalStorage.setItem("location", true);
    }

    const handleOneSignal = async () => {
        if (Userid && !initialized.current) {
            OneSignal.init({
                appId: OneSignalUserAppId,
                safari_web_id: "web.onesignal.auto.xxx",
                notifyButton: {
                    enable: true,
                },
                serviceWorkerParam: { scope: "/" },
                serviceWorkerPath: "OneSignalSDKWorker.js",
                allowLocalhostAsSecureOrigin: true,
            }).then(async () => {

                OneSignal.User.addTags({
                    "userid": Userid,
                });

                initialized.current = true;

            }).catch((error) => {
                // console.error("OneSignal initialization error:", error);
            });
        }
    };

    useEffect(() => {
        const isShowStored = secureLocalStorage.getItem("pwa");

        const shouldShowInstall = isShowStored !== null ? isShowStored : true;
        setIsInstallable(shouldShowInstall);

        if (!shouldShowInstall) return;

        const handleBeforeInstallPrompt = (e) => {
            e.preventDefault();
            setDeferredPrompt(e);
        };

        window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);

        return () => {
            window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
        };
    }, []);


    const handleInstallClick = async () => {
        if (deferredPrompt) {
            deferredPrompt.prompt();
            const { outcome } = await deferredPrompt.userChoice;
            if (outcome === "accepted") {
                secureLocalStorage.setItem("pwa", false);
                setDeferredPrompt(null);
                setIsInstallable(false);
            }
        }
    };

    const handleClosePwaCard = () => {
        setIsInstallable(false);
        secureLocalStorage.setItem("pwa", false);
    }

    const HandleShowLoginPage = () => {
        setShowLoginPage(true);
        setIsInstallable(false);
        secureLocalStorage.setItem("pwa", false);
    }

    const handleShowSearchBox = () => {
        handleModelOpen(SearchRef, "search_list_open", setShowSearch);
        setIsInstallable(false);
        secureLocalStorage.setItem("pwa", false);
    }

    const HandleCloseMode = () => {
        secureLocalStorage.setItem("Guest", false);
        handleModelClose(ShowStoreListRef, "store_list_open", setShowStoreList);
        if (!selectstore && Store) {
            setSelectStore(JSON.parse(Store));
        }
    }

    const handleModelOpen = (refname, className, statename) => {
        statename(true);
        setTimeout(() => {
            refname.current.classList.add(className);
        }, 100);
    }

    const handleModelClose = (refname, className, statename) => {
        refname.current.classList.remove(className);
        setTimeout(() => {
            statename(false);
        }, 500);
    }


    return (
        <div>
            <div className="header fixed top-0 left-0 w-full z-[888]">
                <div className="bg-[#050B20] max-_430_:py-[0px] py-[5px] relative">

                    <div className="text-white width_container py-[8px]">
                        <div className="flex items-center justify-between">

                            <div onClick={HandleMenuShow} className="left_side">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M2.25 6C2.25 5.586 2.586 5.25 3 5.25H21C21.414 5.25 21.75 5.586 21.75 6C21.75 6.414 21.414 6.75 21 6.75H3C2.586 6.75 2.25 6.414 2.25 6ZM21 11.25H3C2.586 11.25 2.25 11.586 2.25 12C2.25 12.414 2.586 12.75 3 12.75H21C21.414 12.75 21.75 12.414 21.75 12C21.75 11.586 21.414 11.25 21 11.25ZM21 17.25H3C2.586 17.25 2.25 17.586 2.25 18C2.25 18.414 2.586 18.75 3 18.75H21C21.414 18.75 21.75 18.414 21.75 18C21.75 17.586 21.414 17.25 21 17.25Z" fill="white" />
                                </svg>
                            </div>

                            <div className="center flex max-_770_:justify-center">
                                <button onClick={() => Navigate("/")} className="flex items-center justify-center gap-[10px]">
                                    <img src={Logo} className='w-[30px]' alt="Logo" />
                                    <h1 className="font-bold text-[20px]">{t("GoMechPro")}</h1>
                                </button>
                            </div>

                            <div className="right_side">
                                <button onClick={handleShowSearchBox} className="flex items-center max-_430_:hidden">
                                    <svg width="24" height="24" viewBox="0 0 24 24" className='' fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M21.53 20.47L17.689 16.629C18.973 15.106 19.75 13.143 19.75 11C19.75 6.175 15.825 2.25 11 2.25C6.175 2.25 2.25 6.175 2.25 11C2.25 15.825 6.175 19.75 11 19.75C13.143 19.75 15.106 18.973 16.629 17.689L20.47 21.53C20.616 21.676 20.808 21.75 21 21.75C21.192 21.75 21.384 21.677 21.53 21.53C21.823 21.238 21.823 20.763 21.53 20.47ZM3.75 11C3.75 7.002 7.002 3.75 11 3.75C14.998 3.75 18.25 7.002 18.25 11C18.25 14.998 14.998 18.25 11 18.25C7.002 18.25 3.75 14.998 3.75 11Z" fill="white" />
                                    </svg>
                                </button>

                                {totalcart !== 0 && <button onClick={() => Navigate("/cart", { state: { title: "Home", path: "/" } })} className="relative max-_430_:hidden">
                                    <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M10.27 21C10.27 21.69 9.71002 22.25 9.02002 22.25C8.33102 22.25 7.76501 21.69 7.76501 21C7.76501 20.31 8.32001 19.75 9.01001 19.75H9.02002C9.71002 19.75 10.27 20.31 10.27 21ZM17.02 19.75H17.01C16.32 19.75 15.765 20.31 15.765 21C15.765 21.69 16.33 22.25 17.02 22.25C17.71 22.25 18.27 21.69 18.27 21C18.27 20.31 17.71 19.75 17.02 19.75ZM21.705 8.492L20.691 14.658C20.428 16.104 19.774 17.75 17 17.75H8.73401C7.37501 17.75 6.20396 16.735 6.01196 15.389L4.50195 4.82401C4.41395 4.21201 3.88301 3.75101 3.26501 3.75101H3C2.586 3.75101 2.25 3.41501 2.25 3.00101C2.25 2.58701 2.586 2.25101 3 2.25101H3.26599C4.62499 2.25101 5.79604 3.266 5.98804 4.612L6.07996 5.25101H19C19.818 5.25101 20.5881 5.611 21.1121 6.239C21.6351 6.866 21.852 7.688 21.705 8.492ZM19.213 14.403L19.3199 13.75H13C12.586 13.75 12.25 13.414 12.25 13C12.25 12.586 12.586 12.25 13 12.25H19.567L20.2271 8.23599C20.2961 7.85799 20.198 7.484 19.959 7.19901C19.72 6.91401 19.371 6.75 18.999 6.75H6.29297L7.49695 15.177C7.58495 15.789 8.11601 16.25 8.73401 16.25H17C18.597 16.25 18.986 15.654 19.213 14.403Z" fill="white" />
                                    </svg>
                                    <div className="w-[17px] h-[17px] flex items-center justify-center bg-white rounded-full absolute -top-[5px] -right-[5px]">
                                        <span className='text-black font-bold text-[14px]'>{totalcart}</span>
                                    </div>
                                </button>}

                                <div>
                                    {Userid
                                        ? (
                                            <div className='user_dropdown_wrapper'>

                                                <div>
                                                    {userimg === "NoPic"
                                                        ? <div className="w-[45px] h-[45px] flex items-center justify-center bg-white rounded-[100%] cursor-pointer">
                                                            <h1 className='text-[#682afb] font-bold text-[20px] -mt-[2px]'>{username.slice(0, 1).toUpperCase()}</h1>
                                                        </div>
                                                        : <img
                                                            src={userimg || null}
                                                            className="w-[45px] h-[45px] object-cover rounded-[100%] cursor-pointer"
                                                            alt="User"
                                                        />}
                                                </div>

                                                <div className="dropdown_box">
                                                    <div className="dropdown_menu">
                                                        {MenuList.map((item, index) => {
                                                            return (
                                                                <div key={index} onClick={() => HandleNavigate(item.path)} className="flex items-center gap-[10px] py-[5px] cursor-pointer group">
                                                                    <div className="w-[20px] text-gray-700 group-hover:text-black">
                                                                        {item.icon}
                                                                    </div>
                                                                    <h1 className='font-[500] text-gray-700 group-hover:text-black whitespace-nowrap'>{t(item.title)}</h1>
                                                                </div>
                                                            );
                                                        })}

                                                        {pagelist.map((item, index) => {
                                                            const Title = item.title.replace(/\s+/g, '_');
                                                            const FinalText = Title.toLowerCase();
                                                            return (
                                                                <div key={index} onClick={() => HandleNavigate(`/page/${FinalText}`)} className="flex items-center gap-[10px] py-[5px] group cursor-pointer">
                                                                    <div className="w-[20px]">
                                                                        <svg width="100%" height="100%" viewBox="0 0 24 24" className='mx-auto text-gray-700 group-hover:text-black' fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                            <path d="M17 4.25H16.73C16.633 2.996 15.821 2.25 14.5 2.25H9.5C8.179 2.25 7.36702 2.996 7.27002 4.25H7C4.582 4.25 3.25 5.582 3.25 8V18C3.25 20.418 4.582 21.75 7 21.75H17C19.418 21.75 20.75 20.418 20.75 18V8C20.75 5.582 19.418 4.25 17 4.25ZM8.75 4.5C8.75 3.911 8.911 3.75 9.5 3.75H14.5C15.089 3.75 15.25 3.911 15.25 4.5V5.5C15.25 6.089 15.089 6.25 14.5 6.25H9.5C8.911 6.25 8.75 6.089 8.75 5.5V4.5ZM19.25 18C19.25 19.577 18.577 20.25 17 20.25H7C5.423 20.25 4.75 19.577 4.75 18V8C4.75 6.423 5.423 5.75 7 5.75H7.27002C7.36702 7.004 8.179 7.75 9.5 7.75H14.5C15.821 7.75 16.633 7.004 16.73 5.75H17C18.577 5.75 19.25 6.423 19.25 8V18ZM15.75 12C15.75 12.414 15.414 12.75 15 12.75H9C8.586 12.75 8.25 12.414 8.25 12C8.25 11.586 8.586 11.25 9 11.25H15C15.414 11.25 15.75 11.586 15.75 12ZM13.75 16C13.75 16.414 13.414 16.75 13 16.75H9C8.586 16.75 8.25 16.414 8.25 16C8.25 15.586 8.586 15.25 9 15.25H13C13.414 15.25 13.75 15.586 13.75 16Z" fill="currentColor" />
                                                                        </svg>
                                                                    </div>
                                                                    <h1 className='font-[500] text-gray-700 group-hover:text-black whitespace-nowrap'>{item.title}</h1>
                                                                </div>
                                                            );
                                                        })}

                                                        <div onClick={HandleLogout} className="flex items-center gap-[10px] group py-[5px] cursor-pointer">
                                                            <div className="w-[20px]">
                                                                <svg width="100%" height="100%" className='mx-auto text-gray-700 group-hover:text-black' viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                    <path d="M18 14L19.2929 12.7071C19.6834 12.3166 19.6834 11.6834 19.2929 11.2929L18 10" stroke="currentcolor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                                    <path d="M19 12L13 12M4 17.2663V7.26633M16 17.2663C16 18.3709 15.1046 19.2663 14 19.2663H10M16 7.26633C16 6.16176 15.1046 5.26633 14 5.26633H10M4.8906 19.8601L6.8906 21.1934C8.21971 22.0795 10 21.1267 10 19.5293V5.00336C10 3.40597 8.21971 2.45319 6.8906 3.33926L4.8906 4.6726C4.3342 5.04353 4 5.66799 4 6.3367V18.196C4 18.8647 4.3342 19.4891 4.8906 19.8601Z" stroke="currentcolor" strokeWidth="1.5" strokeLinecap="round" />
                                                                </svg>
                                                            </div>
                                                            <h1 className='font-[500] text-gray-700 group-hover:text-black'>{t("Log Out")}</h1>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        )
                                        : (
                                            <img
                                                onClick={HandleShowLoginPage}
                                                src="https://cdn.pixabay.com/photo/2023/02/18/11/00/icon-7797704_640.png"
                                                className="w-[45px] h-[45px] object-cover rounded-[100%] cursor-pointer"
                                                alt="Login Icon"
                                            />
                                        )
                                    }
                                </div>

                                {selectcar && <div onClick={HandleShowCarList} className="car_store_box">
                                    <img src={ImgBasUrl + selectcar?.model_img} className="w-full h-full object-cover rounded-full" alt="model_img" />
                                    <div className="tultip top-[60px] -left-[37px]">
                                        <h1 className='whitespace-nowrap font-medium'>Change Vahical</h1>
                                    </div>
                                </div>}

                                {selectstore && <div onClick={() => HandleShowStoreList(1)} className="car_store_box">
                                    <img src={ImgBasUrl + selectstore?.store_logo} className="w-full h-full object-cover rounded-full" alt="model_img" />
                                    <div className="tultip top-[60px] -left-[30px]">
                                        <h1 className='whitespace-nowrap font-medium'>Change Store</h1>
                                    </div>
                                </div>}

                            </div>
                        </div>
                    </div>

                    <div className={`pwa_card ${isInstallable ? "translate-y-0" : "-translate-y-[150%]"}`}>
                        <div className="-translate-x-[50%] bg-white p-[20px] rounded-[12px]">
                            <div className="flex items-start justify-between">
                                <div className="flex items-center gap-[15px] pb-[10px]">
                                    <img src={Logo} className='w-[40px]' alt="logo" />
                                    <div className="">
                                        <h1 className='font-[500] text-[17px] text-gray-700'>GoMechPro</h1>
                                        <p className='text-[14px] text-gray-500'>https://gomechpro.cscodetech.com</p>
                                    </div>
                                </div>
                                <button onClick={handleClosePwaCard}>
                                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M18.53 17.47C18.823 17.763 18.823 18.238 18.53 18.531C18.384 18.677 18.192 18.751 18 18.751C17.808 18.751 17.616 18.678 17.47 18.531L12 13.061L6.52999 18.531C6.38399 18.677 6.19199 18.751 5.99999 18.751C5.80799 18.751 5.61599 18.678 5.46999 18.531C5.17699 18.238 5.17699 17.763 5.46999 17.47L10.94 12L5.46999 6.53005C5.17699 6.23705 5.17699 5.76202 5.46999 5.46902C5.76299 5.17602 6.238 5.17602 6.531 5.46902L12.001 10.939L17.471 5.46902C17.764 5.17602 18.239 5.17602 18.532 5.46902C18.825 5.76202 18.825 6.23705 18.532 6.53005L13.062 12L18.53 17.47Z" fill="#25314C" />
                                    </svg>
                                </button>
                            </div>
                            <h1 className='text-[15px] my-[5px] font-[500] text-gray-700'>Install Progressive Web Application</h1>
                            <p className='text-[14px] text-gray-500'>This site has app functionality. Install it on your device for extensive experience and easy access.</p>

                            <div className="w-full flex justify-end mt-[10px]">
                                <button onClick={handleInstallClick} className='font-[500] border-[1px] border-[black] hover:bg-[#000000c4] duration-[.30s] hover:text-white px-[20px] py-[5px] rounded-[10px]'>Install</button>
                            </div>
                        </div>
                    </div>

                </div>
            </div>

            {showmenu && <div ref={MenuRef} className="menu_list">
                <div className="py-[20px] px-[10px] border-b-[1px] flex items-center justify-between">
                    <h1 className="font-bold text-[20px]">{t("Menu")}</h1>
                    <button onClick={() => handleModelClose(MenuRef, "menu_list_open", setShowMenu)}>
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M18.53 17.47C18.823 17.763 18.823 18.238 18.53 18.531C18.384 18.677 18.192 18.751 18 18.751C17.808 18.751 17.616 18.678 17.47 18.531L12 13.061L6.52999 18.531C6.38399 18.677 6.19199 18.751 5.99999 18.751C5.80799 18.751 5.61599 18.678 5.46999 18.531C5.17699 18.238 5.17699 17.763 5.46999 17.47L10.94 12L5.46999 6.53005C5.17699 6.23705 5.17699 5.76202 5.46999 5.46902C5.76299 5.17602 6.238 5.17602 6.531 5.46902L12.001 10.939L17.471 5.46902C17.764 5.17602 18.239 5.17602 18.532 5.46902C18.825 5.76202 18.825 6.23705 18.532 6.53005L13.062 12L18.53 17.47Z" fill="black" />
                        </svg>
                    </button>
                </div>

                <div className="py-[10px] h-[100%] scroll-container">

                    {selectcar && <div onClick={HandleShowCarList}
                        className="border-[1px] rounded-[10px] py-[10px] px-[15px] cursor-pointer flex items-center justify-between">
                        <div className="flex items-center gap-[10px]">
                            <img src={ImgBasUrl + selectcar?.model_img} className="w-[40px] h-[40px] object-contain rounded-[10px]" alt="model_img" />
                            <h1 className="font-[500] whitespace-nowrap overflow-hidden overflow-ellipsis">{selectcar?.name}</h1>
                        </div>
                        <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M10 16.75C9.80802 16.75 9.61599 16.6771 9.46999 16.5301C9.17699 16.2371 9.17699 15.762 9.46999 15.469L12.94 11.999L9.46999 8.52908C9.17699 8.23608 9.17699 7.76104 9.46999 7.46804C9.76299 7.17504 10.238 7.17504 10.531 7.46804L14.531 11.468C14.824 11.761 14.824 12.2361 14.531 12.5291L10.531 16.5291C10.384 16.6771 10.192 16.75 10 16.75Z" fill="black" />
                        </svg>
                    </div>}

                    {<div onClick={() => HandleShowStoreList(1)}
                        className="border-[1px] rounded-[10px] mt-[5px] py-[10px] px-[15px] cursor-pointer flex items-center justify-between">
                        <div className="flex items-center gap-[10px]">
                            <img src={ImgBasUrl + selectstore?.store_logo} className="w-[40px] h-[40px] object-contain rounded-[10px]" alt="model_img" />
                            <h1 className="font-[500]">{selectstore?.name}</h1>
                        </div>
                        <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M10 16.75C9.80802 16.75 9.61599 16.6771 9.46999 16.5301C9.17699 16.2371 9.17699 15.762 9.46999 15.469L12.94 11.999L9.46999 8.52908C9.17699 8.23608 9.17699 7.76104 9.46999 7.46804C9.76299 7.17504 10.238 7.17504 10.531 7.46804L14.531 11.468C14.824 11.761 14.824 12.2361 14.531 12.5291L10.531 16.5291C10.384 16.6771 10.192 16.75 10 16.75Z" fill="black" />
                        </svg>
                    </div>}

                    <div className="mb-[60px]">
                        {MenuList.map((item, index) => {
                            return <div key={index} onClick={() => HandleNavigate(item.path)} className="py-[10px] px-[15px] cursor-pointer flex items-center justify-between">
                                <div className="flex items-center gap-[10px]">
                                    <div className="w-[25px]">
                                        {item.icon}
                                    </div>
                                    <h1 className="font-[500]">{item.title}</h1>
                                </div>
                                <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M10 16.75C9.80802 16.75 9.61599 16.6771 9.46999 16.5301C9.17699 16.2371 9.17699 15.762 9.46999 15.469L12.94 11.999L9.46999 8.52908C9.17699 8.23608 9.17699 7.76104 9.46999 7.46804C9.76299 7.17504 10.238 7.17504 10.531 7.46804L14.531 11.468C14.824 11.761 14.824 12.2361 14.531 12.5291L10.531 16.5291C10.384 16.6771 10.192 16.75 10 16.75Z" fill="black"></path>
                                </svg>
                            </div>
                        })}
                        {pagelist.map((item, index) => {
                            const Title = item.title.replace(/\s+/g, '_');
                            const FinalText = Title.toLowerCase();
                            return (
                                <div key={index} onClick={() => HandleNavigate(`/page/${FinalText}`)} className="py-[10px] px-[15px] cursor-pointer flex items-center justify-between">
                                    <div className="flex items-center gap-[10px]">
                                        <div className="w-[25px]">
                                            <svg width="100%" height="100%" viewBox="0 0 24 24" className='mx-auto' fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M17 4.25H16.73C16.633 2.996 15.821 2.25 14.5 2.25H9.5C8.179 2.25 7.36702 2.996 7.27002 4.25H7C4.582 4.25 3.25 5.582 3.25 8V18C3.25 20.418 4.582 21.75 7 21.75H17C19.418 21.75 20.75 20.418 20.75 18V8C20.75 5.582 19.418 4.25 17 4.25ZM8.75 4.5C8.75 3.911 8.911 3.75 9.5 3.75H14.5C15.089 3.75 15.25 3.911 15.25 4.5V5.5C15.25 6.089 15.089 6.25 14.5 6.25H9.5C8.911 6.25 8.75 6.089 8.75 5.5V4.5ZM19.25 18C19.25 19.577 18.577 20.25 17 20.25H7C5.423 20.25 4.75 19.577 4.75 18V8C4.75 6.423 5.423 5.75 7 5.75H7.27002C7.36702 7.004 8.179 7.75 9.5 7.75H14.5C15.821 7.75 16.633 7.004 16.73 5.75H17C18.577 5.75 19.25 6.423 19.25 8V18ZM15.75 12C15.75 12.414 15.414 12.75 15 12.75H9C8.586 12.75 8.25 12.414 8.25 12C8.25 11.586 8.586 11.25 9 11.25H15C15.414 11.25 15.75 11.586 15.75 12ZM13.75 16C13.75 16.414 13.414 16.75 13 16.75H9C8.586 16.75 8.25 16.414 8.25 16C8.25 15.586 8.586 15.25 9 15.25H13C13.414 15.25 13.75 15.586 13.75 16Z" fill="currentColor" />
                                            </svg>
                                        </div>
                                        <h1 className="font-[500]">{item.title}</h1>
                                    </div>
                                    <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M10 16.75C9.80802 16.75 9.61599 16.6771 9.46999 16.5301C9.17699 16.2371 9.17699 15.762 9.46999 15.469L12.94 11.999L9.46999 8.52908C9.17699 8.23608 9.17699 7.76104 9.46999 7.46804C9.76299 7.17504 10.238 7.17504 10.531 7.46804L14.531 11.468C14.824 11.761 14.824 12.2361 14.531 12.5291L10.531 16.5291C10.384 16.6771 10.192 16.75 10 16.75Z" fill="black"></path>
                                    </svg>
                                </div>
                            );
                        })}
                        <div onClick={HandleLogout} className="py-[10px] px-[15px] cursor-pointer flex items-center justify-between">
                            <div className="flex items-center gap-[10px]">
                                <div className="w-[25px]">
                                    <svg width="100%" height="100%" className='mx-auto text-gray-700 group-hover:text-black' viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M18 14L19.2929 12.7071C19.6834 12.3166 19.6834 11.6834 19.2929 11.2929L18 10" stroke="currentcolor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                        <path d="M19 12L13 12M4 17.2663V7.26633M16 17.2663C16 18.3709 15.1046 19.2663 14 19.2663H10M16 7.26633C16 6.16176 15.1046 5.26633 14 5.26633H10M4.8906 19.8601L6.8906 21.1934C8.21971 22.0795 10 21.1267 10 19.5293V5.00336C10 3.40597 8.21971 2.45319 6.8906 3.33926L4.8906 4.6726C4.3342 5.04353 4 5.66799 4 6.3367V18.196C4 18.8647 4.3342 19.4891 4.8906 19.8601Z" stroke="currentcolor" strokeWidth="1.5" strokeLinecap="round" />
                                    </svg>
                                </div>
                                <h1 className="font-[500]">{t("Log Out")}</h1>
                            </div>
                            <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M10 16.75C9.80802 16.75 9.61599 16.6771 9.46999 16.5301C9.17699 16.2371 9.17699 15.762 9.46999 15.469L12.94 11.999L9.46999 8.52908C9.17699 8.23608 9.17699 7.76104 9.46999 7.46804C9.76299 7.17504 10.238 7.17504 10.531 7.46804L14.531 11.468C14.824 11.761 14.824 12.2361 14.531 12.5291L10.531 16.5291C10.384 16.6771 10.192 16.75 10 16.75Z" fill="black"></path>
                            </svg>
                        </div>
                    </div>

                </div>
            </div>}

            {showloginpage && <div onClick={() => setShowLoginPage(false)} className="bottem_sheet items-center">
                <div onClick={(e) => e.stopPropagation()} className="login_model">
                    <Login />
                </div>
            </div>}

            {showsignuppage && <div onClick={() => setShowSignupPage(false)} className="bottem_sheet items-center">
                <div onClick={(e) => e.stopPropagation()} className="login_model max-_430_:h-[700px] scroll-container">
                    <Signup />
                </div>
            </div>}

            {showselectcarpage && <div onClick={HandleCloseCarModel} className="bottem_sheet items-center">
                <div onClick={(e) => e.stopPropagation()} className="w-[100%] relative">
                    <SelectCar setShowSelectCarPage={setShowSelectCarPage} setShowStoreList={setShowStoreList} />
                </div>
            </div>}

            {showstorelist && <div ref={ShowStoreListRef} className="store_list overflow-x-auto" >
                <div className="px-[20px] h-[100%]">
                    <div className="flex items-center gap-[10px] sticky top-0 bg-white py-[20px]">
                        <svg onClick={HandleCloseMode} className="cursor-pointer" width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M21.7501 12C21.7501 12.414 21.4141 12.75 21.0001 12.75H4.81115L10.5311 18.47C10.8241 18.763 10.8241 19.238 10.5311 19.531C10.3851 19.677 10.1931 19.751 10.0011 19.751C9.80909 19.751 9.61706 19.678 9.47106 19.531L2.47106 12.531C2.40206 12.462 2.3472 12.3791 2.3092 12.2871C2.2332 12.1041 2.2332 11.8971 2.3092 11.7141C2.3472 11.6221 2.40206 11.539 2.47106 11.47L9.47106 4.46999C9.76406 4.17699 10.2391 4.17699 10.5321 4.46999C10.8251 4.76299 10.8251 5.23803 10.5321 5.53103L4.81213 11.251H21.0001C21.4141 11.25 21.7501 11.586 21.7501 12Z" fill="#25314C" />
                        </svg>
                        <h1 className="font-bold text-[20px]">{t("Select Store")}</h1>
                    </div>

                    {apiloading
                        ? <div className="h-[100%] flex items-center justify-center -mt-[120px]">
                            <div className="mt-[120px]">
                                <div className="loader2 mx-auto"></div>
                            </div>
                        </div>
                        : <div className="pb-[10px] h-[calc(100%-80px)]">
                            <div className="">
                                {storelist?.length >= 1
                                    ? storelist?.map((item, index) => {
                                        return <div key={index} onClick={() => HandleSelectStoreList(item)} className={`${selectstore.store_id === item.store_id && "border-[#682afb] bg-[#692afb17]"} mt-[5px] border-[2px] rounded-[10px] p-[10px] cursor-pointer`}>
                                            <div className="flex items-center gap-[10px]">
                                                <div className="">
                                                    <img src={ImgBasUrl + item.store_cover} className="max-w-[50px] h-[50px] min-w-[50px] rounded-[10px]" alt="store_cover" />
                                                </div>
                                                <div className="overflow-hidden">
                                                    <h1 className="font-bold text-[18px] whitespace-nowrap overflow-ellipsis overflow-hidden">{item.store_title}</h1>
                                                    <div className="text-gray-600 flex items-center gap-[3px]">
                                                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path fillRule="evenodd" clipRule="evenodd" d="M12 22C15.375 22 21 15.7981 21 10.8889C21 5.97969 16.9706 2 12 2C7.02944 2 3 5.97969 3 10.8889C3 15.7981 8.625 22 12 22ZM12 14C13.6569 14 15 12.6569 15 11C15 9.34315 13.6569 8 12 8C10.3431 8 9 9.34315 9 11C9 12.6569 10.3431 14 12 14Z" fill="currentcolor" />
                                                        </svg>
                                                        <span>{item.store_distance}</span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="flex flex-wrap items-center gap-[5px] mt-[10px]">
                                                {item.store_tags.map((item, index) => {
                                                    return <span key={index} className="border-[1px] border-gray-400 rounded-[5px] px-[5px] whitespace-nowrap">{item}</span>
                                                })}
                                            </div>
                                        </div>

                                    })
                                    : <div className="h-[100%] -mt-[70px] flex items-center justify-center text-center">
                                        <h1 className='font-bold text-gray-600 text-[17px]'>{storeerror}</h1>
                                    </div>
                                }
                            </div>
                        </div>}

                </div>
            </div>}

            {selectmodel && <div className="bottem_sheet items-end">
                <div className="login_model">
                    <div className="flex items-center gap-[10px]">
                        <svg onClick={() => setSelectModel("")} className="cursor-pointer" width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M21.7501 12C21.7501 12.414 21.4141 12.75 21.0001 12.75H4.81115L10.5311 18.47C10.8241 18.763 10.8241 19.238 10.5311 19.531C10.3851 19.677 10.1931 19.751 10.0011 19.751C9.80909 19.751 9.61706 19.678 9.47106 19.531L2.47106 12.531C2.40206 12.462 2.3472 12.3791 2.3092 12.2871C2.2332 12.1041 2.2332 11.8971 2.3092 11.7141C2.3472 11.6221 2.40206 11.539 2.47106 11.47L9.47106 4.46999C9.76406 4.17699 10.2391 4.17699 10.5321 4.46999C10.8251 4.76299 10.8251 5.23803 10.5321 5.53103L4.81213 11.251H21.0001C21.4141 11.25 21.7501 11.586 21.7501 12Z" fill="#25314C" />
                        </svg>
                        <h1 className="font-[500] text-[20px] max-_430_:text-[16px]">{t("Select Your Vehicle Details")}</h1>
                    </div>
                    <div className="text-center">
                        <img src={ImgBasUrl + selectmodel?.model_img} className="w-[50%] h-full object-cover mx-auto" alt="model" />
                        <h1 className="font-[500] text-[18px] text-gray-500">{selectmodel?.ctitle}</h1>
                    </div>
                    <div className="">
                        <h1 className="font-[500] mb-[5px] text-[18px]">{t("Register Number")}</h1>
                        <input type="text" onChange={(e) => setInput(e.target.value)} className="border-[2px] w-full px-[10px] py-[5px] outline-none focus-within:border-[#682afb] rounded-[10px]" placeholder={t("Enter Your Register Number...")} />
                    </div>
                    <div className="mt-[10px]">
                        <h1 className="font-[500] mb-[5px] text-[18px]">{t("Car Transmission Type")}</h1>
                        <div className="flex items-center gap-[20px]">
                            {["Manual", "Automatic"].map((item, index) => {
                                return <div key={index} onClick={() => setSelectGearType(item)} className={`border-[2px] ${selectgeartype === item && "border-[#682afb] bg-[#692afb21]"} px-[10px] py-[5px] rounded-[10px] cursor-pointer`}>
                                    <div className="flex items-center gap-[10px]">
                                        <div className={`w-[18px] h-[18px] rounded-[50px] border-[2px] ${selectgeartype === item && "border-[#682afb]"} flex items-center justify-center`}>
                                            {selectgeartype === item && <div className="w-[10px] h-[10px] bg-[#682afb] rounded-[50px]"></div>}
                                        </div>
                                        <h1 className={selectgeartype === item && "text-[#682afb]"}>{t(item)}</h1>
                                    </div>
                                </div>
                            })}
                        </div>
                    </div>
                    <div className="mt-[10px]">
                        <h1 className="font-[500] mb-[5px] text-[18px]">{t("Car Fuel Type")}</h1>
                        <div className="flex items-center gap-[20px]">
                            <div onClick={() => setSelectFuelType("Petrol")} className={`py-[5px] px-[10px] text-center border-[2px] rounded-[10px] cursor-pointer ${selectfueltype === "Petrol" && "border-[#682afb] bg-[#692afb21]"}`}>
                                <img src={PetrolLogo} className="w-[70px]" alt="" />
                                <h1 className={selectfueltype === "Petrol" && "text-[#682afb]"}>{t("Petrol")}</h1>
                            </div>
                            <div onClick={() => setSelectFuelType("Diesel")} className={`py-[5px] px-[10px] text-center border-[2px] rounded-[10px] cursor-pointer ${selectfueltype === "Diesel" && "border-[#682afb] bg-[#692afb21]"}`}>
                                <img src={DieselLogo} className="w-[70px]" alt="" />
                                <h1 className={selectfueltype === "Diesel" && "text-[#682afb]"}>{t("Diesel")}</h1>
                            </div>
                            <div onClick={() => setSelectFuelType("CNG")} className={`py-[5px] px-[10px] text-center border-[2px] rounded-[10px] cursor-pointer ${selectfueltype === "CNG" && "border-[#682afb] bg-[#692afb21]"}`}>
                                <img src={CngLogo} className="w-[70px]" alt="" />
                                <h1 className={selectfueltype === "CNG" && "text-[#682afb]"}>{t("CNG")}</h1>
                            </div>
                        </div>
                    </div>
                    <button onClick={HandleAddVehicle} className="button rounded-[50px] mt-[20px]">
                        {apiloading
                            ? <div className="loader mx-auto"></div>
                            : <span>{t("Add Vehicle")}</span>}
                    </button>
                </div>
            </div>}

            {showcarlist && <div ref={ShowCarListRef} className="store_list overflow-x-auto">
                <div className="px-[20px] h-full relative">
                    <div className="flex items-center gap-[10px] bg-white py-[20px] sticky top-0">
                        <svg onClick={() => handleModelClose(ShowCarListRef, "store_list_open", setShowCarList)} className="cursor-pointer" width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M21.7501 12C21.7501 12.414 21.4141 12.75 21.0001 12.75H4.81115L10.5311 18.47C10.8241 18.763 10.8241 19.238 10.5311 19.531C10.3851 19.677 10.1931 19.751 10.0011 19.751C9.80909 19.751 9.61706 19.678 9.47106 19.531L2.47106 12.531C2.40206 12.462 2.3472 12.3791 2.3092 12.2871C2.2332 12.1041 2.2332 11.8971 2.3092 11.7141C2.3472 11.6221 2.40206 11.539 2.47106 11.47L9.47106 4.46999C9.76406 4.17699 10.2391 4.17699 10.5321 4.46999C10.8251 4.76299 10.8251 5.23803 10.5321 5.53103L4.81213 11.251H21.0001C21.4141 11.25 21.7501 11.586 21.7501 12Z" fill="#25314C" />
                        </svg>
                        <h1 className="font-bold text-[20px]">{t("Select Vehicle")}</h1>
                    </div>
                    <div className="h-full -mt-[140px]">
                        <div className="pt-[140px]">
                            {carlist.map((item, index) => {
                                return <div key={index} onClick={() => HandleSelectCar(item, index)} className={`border-[2px] mt-[5px] ${selectcar?.index === index && "border-[#682afb]"} rounded-[10px] p-[10px] cursor-pointer overflow-hidden`}>
                                    <div className="flex items-start justify-between">
                                        <div className="flex items-center gap-[10px] overflow-hidden">
                                            <img src={ImgBasUrl + item.model_img} className="max-w-[80px] min-w-[80px]" alt="" />
                                            <div className="overflow-hidden">
                                                <h1 className="font-[500] text-[17px] whitespace-nowrap overflow-ellipsis overflow-hidden">{item.brand_name} {item.model_name}</h1>
                                                <span className="text-gray-500">{item.fuel_type}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            })}
                        </div>
                        <div className="bg-white py-[10px] sticky bottom-0">
                            <button onClick={() => { setShowSelectCarPage(true); setShowCarList(false) }} className="w-full border-[2px] border-dashed border-[#682afb] rounded-[10px] py-[8px] font-[500] text-[#682afb]">{t("Add New Vehicle +")}</button>
                        </div>
                    </div>
                </div>
            </div>}

            {showlanglist && <div onClick={() => setShowLangList(false)} className="bottem_sheet items-center">
                <div style={{ borderRadius: "10px" }} onClick={(e) => e.stopPropagation()} className="bottem_box py-[10px] px-[15px]">
                    <div className="mt-[7px]">
                        {LanguageList.map((item, index) => {
                            return <div key={index} onClick={() => { setSelectLang(item.id); setShowLangList(false) }} className="border-[1px] py-[8px] px-[10px] mb-[10px] rounded-[10px] cursor-pointer">
                                <div className="flex items-center justify-between">
                                    <div className="flex items-center gap-[10px]">
                                        <img src={item.img} className='w-[30px]' alt="language-img" />
                                        <h1 className='font-[500]'>{item.name}</h1>
                                    </div>
                                    <div className={`w-[18px] h-[18px] border-[2px] ${selectlang === item.id && "border-[#682afb]"} rounded-full p-[2px] duration-[0.5s]`}>
                                        <div className={`w-full h-full rounded-full ${selectlang === item.id && "bg-[#682afb]"} duration-[0.5s]`}></div>
                                    </div>
                                </div>
                            </div>
                        })}
                    </div>
                </div>
            </div>}

            {showsearch && <div ref={SearchRef} onScroll={handleScroll} className="search_list overflow-x-auto">
                <div className="px-[20px] h-[100%]">
                    <div className="sticky top-0 bg-white pt-[20px] pb-[10px]">
                        <div className="flex items-center gap-[10px]">
                            <svg onClick={() => handleModelClose(SearchRef, "search_list_open", setShowSearch)} className="cursor-pointer" width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M21.7501 12C21.7501 12.414 21.4141 12.75 21.0001 12.75H4.81115L10.5311 18.47C10.8241 18.763 10.8241 19.238 10.5311 19.531C10.3851 19.677 10.1931 19.751 10.0011 19.751C9.80909 19.751 9.61706 19.678 9.47106 19.531L2.47106 12.531C2.40206 12.462 2.3472 12.3791 2.3092 12.2871C2.2332 12.1041 2.2332 11.8971 2.3092 11.7141C2.3472 11.6221 2.40206 11.539 2.47106 11.47L9.47106 4.46999C9.76406 4.17699 10.2391 4.17699 10.5321 4.46999C10.8251 4.76299 10.8251 5.23803 10.5321 5.53103L4.81213 11.251H21.0001C21.4141 11.25 21.7501 11.586 21.7501 12Z" fill="#25314C" />
                            </svg>
                            <h1 className="font-bold text-[20px]">{t("Search Services")}</h1>
                        </div>
                        <div className="flex items-center border-b-[2px] mt-[10px]">
                            <svg width="22" height="22" viewBox="0 0 24 24" className='' fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M21.53 20.47L17.689 16.629C18.973 15.106 19.75 13.143 19.75 11C19.75 6.175 15.825 2.25 11 2.25C6.175 2.25 2.25 6.175 2.25 11C2.25 15.825 6.175 19.75 11 19.75C13.143 19.75 15.106 18.973 16.629 17.689L20.47 21.53C20.616 21.676 20.808 21.75 21 21.75C21.192 21.75 21.384 21.677 21.53 21.53C21.823 21.238 21.823 20.763 21.53 20.47ZM3.75 11C3.75 7.002 7.002 3.75 11 3.75C14.998 3.75 18.25 7.002 18.25 11C18.25 14.998 14.998 18.25 11 18.25C7.002 18.25 3.75 14.998 3.75 11Z" fill="black" />
                            </svg>
                            <input type="text" value={search} onChange={(e) => setSearch(e.target.value)} className='w-full bg-transparent outline-none px-[10px] py-[5px] text-black' placeholder={t('Search service')} />
                        </div>

                        <div className="flex items-center mt-[10px] gap-[10px]">
                            <button onClick={() => setSearchBtn(0)} className={`w-full font-[500] py-[5px] rounded-[50px] ${searchbtn === 0 && "bg-[#682afb] text-white"}`}>{t("Services")}</button>
                            <button onClick={() => setSearchBtn(1)} className={`w-full font-[500] py-[5px] rounded-[50px] ${searchbtn === 1 && "bg-[#682afb] text-white"}`}>{t("Accessories")}</button>
                        </div>
                    </div>

                    {searchlod
                        ? <div className="h-[calc(100%-150px)] flex items-center justify-center">
                            <div className="loader2 mx-auto"></div>
                        </div>
                        : <div className="pb-[10px] h-[calc(100%-150px)]">
                            {search
                                ? <div className="pb-[10px] h-full">
                                    {searchbtn === 0
                                        ? <div className="h-full">
                                            {(searchservicelist.length >= 1
                                                ? searchservicelist.map((item, index) => {
                                                    return <div key={index} onClick={() => HandleNavigateDetails(item)} className={`bg-white border-[1px] rounded-[10px] w-full p-[10px] ${index >= 1 && "mt-[10px]"} rounded-[10px] cursor-pointer`}>
                                                        <div className="flex items-center gap-[10px] overflow-hidden">
                                                            <img src={ImgBasUrl + item.service_img} className='w-[80px] h-[80px] rounded-[10px] border-[1px] object-cover' alt="service_img" />
                                                            <div className="overflow-hidden">
                                                                <h1 className='font-[500] text-[16px] whitespace-nowrap overflow-hidden overflow-ellipsis'>{item.service_title}</h1>
                                                                <p className='text-[15px] leading-5'>{item.service_subtitle}</p>
                                                                <div className="flex items-center gap-[5px] text-[15px]">
                                                                    <span className="line-through text-gray-500">{Currency}{item.price}</span>
                                                                    <h1 className="font-bold">{Currency}{item.discount_price}</h1>
                                                                    <p className="text-green-600">{item.discount_percentage}% {t("OFF")}</p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                })
                                                : <div className="w-full h-[100%] bg-white rounded-[10px] flex items-center justify-center">
                                                    <h1 className='font-[500] text-gray-500'>{errortext}</h1>
                                                </div>)}
                                        </div>
                                        : <div className="h-full">
                                            {(searchaccessorilist.length >= 1
                                                ? searchaccessorilist.map((item, index) => {
                                                    return <AccessoriesList key={index} index={index} item={item} ImgBasUrl={ImgBasUrl} Currency={Currency} handleAddToCart={handleAddToCart} handleDecrement={handleDecrement} handleIncrement={handleIncrement} />
                                                })
                                                : <div className="w-full h-[100%] bg-white rounded-[10px] flex items-center justify-center">
                                                    <h1 className='font-[500] text-gray-500'>{errortext}</h1>
                                                </div>)}
                                        </div>}
                                </div>
                                : <div className="h-[calc(100%-150px)] flex items-center justify-center">
                                    <h1 className='mt-[70px] text-[17px] font-bold text-gray-500'>{t("Search Data !!")}</h1>
                                </div>}
                        </div>}
                </div>
            </div>}

            {locationError && (
                <div className="px-[15px] py-[15px] w-full h-full fixed top-0 left-0 flex items-center justify-center bg-black bg-opacity-50 z-[999]">
                    <div className="w-[25%] max-_430_:w-[100%] max-_768_:w-[75%] max-_1030_:w-[35%] max-_1500_:w-[25%] bg-white rounded-[15px] px-[15px] py-[10px]">
                        <div className="">
                            <h2 className="m-0 text-center font-[500] text-[17px]">{t('Enable Location Services')}</h2>
                            <img src={LocationImg} alt="" />
                            <div className="my-3">
                                <div className="flex gap-[10px]">
                                    <span className="text-[18px]">1.</span>
                                    <h6>{t("To provide accurate services, please enable your location.")}</h6>
                                </div>
                                <div className="flex gap-[5px]">
                                    <span className="text-[18px]">2.</span>
                                    <h6> {t("Allow location access when prompted. If not prompted, enable it in your browser settings.")}</h6>
                                </div>
                                <h6>🔄 {t("Refresh the page after enabling.")}</h6>
                            </div>
                            <button onClick={HandleLocationEnable} className="bg-[#682afb] text-white w-[100%] rounded-[5px] py-[5px] mt-2 font-[500]">{t("Enable Now")}</button>
                        </div>
                    </div>
                </div>
            )}

            {showcarlist && <div onClick={() => handleModelClose(ShowCarListRef, "store_list_open", setShowCarList)} className="overlay z-[888]"></div>}
            {showmenu && <div onClick={() => handleModelClose(MenuRef, "menu_list_open", setShowMenu)} className="overlay z-[888]"></div>}
            {showstorelist && <div onClick={HandleCloseMode} className="overlay z-[888]"></div>}
            {showsearch && <div onClick={() => { handleModelClose(SearchRef, "search_list_open", setShowSearch); setSearch(""); setSearchBtn(0); }} className="overlay z-[888]"></div>}

        </div>
    )
}

export default Header

export const AccessoriesList = ({ index, item, ImgBasUrl, Currency, handleAddToCart, handleDecrement, handleIncrement }) => {

    const { t } = useTranslation();
    const Userid = secureLocalStorage.getItem("Userid");


    const isSelected = item.totalcart >= 1;
    const [showmore, setShowMore] = useState(false);

    return <div className={`bg-white border-[1px] rounded-[10px] w-full p-[10px] ${index >= 1 && "mt-[10px]"} rounded-[10px]`}>
        <div className="flex items-start gap-[10px]">
            <div className="w-[25%]">
                <img src={ImgBasUrl + item.img} className='w-full h-[90px] rounded-[10px] border-[1px] object-cover' alt="img" />
                {Userid && (!isSelected
                    ? <button onClick={() => handleAddToCart(item.id, isSelected)} className={`w-full border-[1px] border-[#682afb] text-[#682afb] py-[2px] font-[500] rounded-[5px] mt-[5px]`}>{t("ADD")}</button>
                    : <div className="w-full text-center border-[1px] border-[#682afb] text-[#682afb] font-[500] rounded-[5px] mt-[5px]">
                        <div className="flex items-center justify-between">
                            <button onClick={() => handleDecrement(item.id)} className='bg-[#682afb] text-white py-[1px] px-[10px] text-[17px]'>-</button>
                            <span className='py-[2px] bg-[#692afb44] w-full'>{item.totalcart}</span>
                            <button onClick={() => handleIncrement(item.id)} className='bg-[#682afb] text-white py-[1px] px-[10px] text-[17px]'>+</button>
                        </div>
                    </div>)}
            </div>
            <div className="overflow-hidden w-[80%]">
                <h1 className='font-[500] text-[16px] leading-5'>{item.title}</h1>
                <p className='text-[15px] whitespace-nowrap overflow-hidden overflow-ellipsis'>{item.tags}</p>
                <div className="flex items-center gap-[5px] text-[15px]">
                    <span className="line-through text-gray-500">{Currency}{item.price}</span>
                    <h1 className="font-bold">{Currency}{item.discount_price}</h1>
                    <p className="text-green-600">{item.discount_percentage}% {t("OFF")}</p>
                </div>
                {showmore && <div className="">
                    {item.feature_tags.split(',').map((item, index) => {
                        return <p key={index} className="text-gray-600 text-[16px] whitespace-nowrap overflow-hidden overflow-ellipsis">• {item.trim()}</p>
                    })}
                </div>}
                <button onClick={() => setShowMore(!showmore)} className='text-[#682afb] font-[500] text-[15px] mt-[12px]'>{showmore ? t("Show Less") : t("Show More")}</button>
            </div>
        </div>

    </div>
}
/* jshint ignore:end */